/**
 * Created by Ella Ma on 02/02/2021.
 * Description:
 * Workflow for Admin Console
 * ------ maintenance history ------
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createSelector, select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from '../../../../redux';
import { adminPageRoutingMap } from '../../admin-page-setting.constants';
import { AdminPageSetting } from '../../admin-page-setting.model';
import { filter } from 'rxjs/operators';
import { WorkflowAdminVisibility } from '../../../../tamalelibs/redux/actions/workflow.actions';
import { businessConstants } from '../../../../constants/business.constants';

@Component({
    selector: 'tam-admin-workflow-page',
    templateUrl: './admin-workflow-page.component.html',
    styleUrls: ['./admin-workflow-page.component.scss']
})
export class AdminWorkflowPageComponent implements OnInit, OnDestroy {
    data = { id: 'WORKFLOW SETTINGS', hide: false, label: 'Hide Workflow on Menu' };
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _route: ActivatedRoute,
        private _store: Store<AppState>,
    ) {
    }

    ngOnInit() {
        this._handlePageRouting(this._route.snapshot.data['page']);
        this._initSubscriptions();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    changeEnable(hide: boolean) {
        this._store.dispatch(new WorkflowAdminVisibility(!hide));
    }

    private _handlePageRouting(currPageUrl: string) {
        const pageSettings: AdminPageSetting = adminPageRoutingMap.get(currPageUrl);
        this.data.id = pageSettings.id;
    }

    private _initSubscriptions() {
        this._destroySubscriptions.push(
            this._store.pipe(
                select(createSelector(state => state[businessConstants.globalConfig.systemConfig], (state) => state ? state[businessConstants.globalConfig.workflow] : null)),
                filter(state => !!state)
            ).subscribe(this._onSystemConfigChange.bind(this))
        );
    }

    private _onSystemConfigChange(workfow: { enable: boolean }) {
        this.data.hide = !workfow.enable;
    }

}
